'use client';
import { useEffect } from 'react';

/**
 * Dev-only: connect Reticle (AI-agent runtime verification) after hydration.
 * Mounted from app/layout.tsx only when NODE_ENV === 'development'; withReticle() in
 * next.config.js is a no-op for production builds.
 */
export function ReticleDev() {
	useEffect(() => {
		if (process.env.NODE_ENV !== 'development') return;
		void Promise.all([
			import('@reticlehq/react'),
			import('@/store/useAppStore'),
		]).then(
			([
				{ reticle, install, registerStore, registerCapabilities },
				{ default: useAppStore },
			]) => {
				install();
				// Provided by withReticle(): pairing token, repo root, and the discovered daemon URL.
				const token = process.env.NEXT_PUBLIC_RETICLE_TOKEN;
				const root = process.env.NEXT_PUBLIC_RETICLE_ROOT;
				const url = process.env.NEXT_PUBLIC_RETICLE_URL;
				reticle.connect({
					projectId: 'stytrix-ui-4de65a48',
					...(url ? { url } : {}),
					...(token ? { token } : {}),
					...(root ? { root } : {}),
				});
				registerStore('app', useAppStore);
				registerCapabilities({
					testids: [
						'activation-account',
						'tour-account',
						'outside',
						'edit-toolbar-settings',
						'file',
					],
					signals: [],
					stores: ['app'],
				});
			},
		);
	}, []);
	return null;
}
